import fp from 'lodash/fp'
import { combine, withCallback } from 'react-hooks-combine'
import { withFormModel, withMobxAutorun } from 'shared/hooks'
import { spec, validators } from 'utils/validation'

import AthleteFiltersComponent from './component'

export const AthleteFilters = combine(
  withFormModel(
    {
      search: {
        initialValue: '',
        spec: spec.flow(validators.any.required),
      },
    },
    { id: 'athlete-filters-form' }
  ),

  withCallback(
    'onSearchRequest',
    (_state, { debounce, onSearch }) => {
      return fp.isNumber(debounce) ? fp.debounce(debounce, onSearch) : onSearch
    },
    ['debounce', 'onSearch']
  ),

  withMobxAutorun(({ firstRun, state: { form, onSearchRequest } }) => {
    const search = form.getControl('search')
    const query = search.value

    if (firstRun) {
      return
    }

    onSearchRequest(query)
  })
)(AthleteFiltersComponent)
